import { useEffect } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { appConfig } from '@/config/app';
import { checkoutGateway, setPaddleCustomer } from './paddle';

/**
 * Paddle Retain: называет Paddle.js залогиненного покупателя (pwCustomer по email),
 * а у того, кто уже клиент Paddle (`has_paddle_customer` из /me), поднимает SDK без
 * чекаута — иначе in-app подсказка «обнови способ оплаты» при past_due не покажется:
 * Upgrade такому пользователю не рисуется, и первой попытки оплаты у него не будет.
 * Гость и пользователь без клиента Paddle SDK заранее не грузят — он поднимется
 * первой попыткой оплаты. Отказ загрузки здесь молчит: чекаут повторит её сам.
 */
export function usePaddleRetain(): void {
  const { user, isAccessResolved } = useAuth();
  const email = user?.email ?? null;
  // Только по подтверждённому /me: объект из localStorage может описывать прошлый визит.
  const isPaddleCustomer = isAccessResolved && !!user?.has_paddle_customer;

  useEffect(() => {
    setPaddleCustomer(email);
  }, [email]);

  useEffect(() => {
    if (!isPaddleCustomer || appConfig.apiMode !== 'live') return;
    checkoutGateway.ensureReady().catch(() => {});
  }, [isPaddleCustomer]);
}
